import { Box, styledComponent } from '@hermes/web-components'

export const NavBarContainer = styledComponent(Box)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 999,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff'
}))

export const NavBarBodyContainer = styledComponent(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '93px',
  width: '100%',
  margin: '0 auto',
  padding: '0 16px',

  [theme.breakpoints.down('md')]: {
    height: '57px',
    width: 'calc(100%-32px)'
  }
}))

export const NavBarContentContainer = styledComponent(Box)(() => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '670px',
  width: '100%',
  margin: '0 auto'
}))

export const AbsoluteBoxCenterContent = styledComponent(Box)(() => ({
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%'
}))

export const Divider = styledComponent(Box)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${theme.palette.divider}`
}))
